module.exports = __webpack_public_path__ + "img/chuanbo.89462b15.png";